<template>
  <content-card title="Archiv" cardIcon="fas fa-archive">
    <template v-slot:body>
      <p class="card-text">Hier findest du alle deine vergangenen und abgelehnten Ferienanträge</p>
      <vacation-table pageSection="VacationsArchive" />
    </template>
  </content-card>
</template>
<script lang="ts">
import Vue from 'vue';
import { ContentCard } from 'rey-smartmes-ui';
import VacationTable from '@/components/VacationTable.vue';

export default Vue.extend({
  name: 'employee-archive',
  components: { ContentCard, VacationTable }
});
</script>
